import { Badge } from 'components'
import { EdiStatus, EdiStatusOptions } from 'constants/enums'

interface StatusBadgeProps {
  status: EdiStatus
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const getStatusColor = (status: EdiStatus) => {
    switch (status) {
      case EdiStatus.FAIL:
        return 'danger'
      case EdiStatus.PROCESSED:
        return 'success'
      case EdiStatus.PROCESSED_WITH_ISSUE:
        return 'warning'
      case EdiStatus.PROCESSING:
      case EdiStatus.REPROCESSING_REQUESTED:
        return 'info'
    }
  }

  return (
    <Badge appearance="soft" color={getStatusColor(status)}>
      {EdiStatusOptions[status]}
    </Badge>
  )
}
